<div class="search">
    <div class="search-wrapper">
        <form [formGroup]="skuForm" (ngSubmit)="searchForSku()">
            <div class="sku-search">
                <mat-form-field class="small">
                    <mat-label>{{'label.skusearch' | translate}}</mat-label>
                    <input matInput formControlName="sku">
                </mat-form-field>
                <span  class="search-icon" (click)="searchForSku()"><mat-icon fontIcon="database_search"></mat-icon></span>
            </div>
        </form>
        <form [formGroup]="searchForm" (ngSubmit)="search()">
            <div class="text-search">
                <mat-form-field class="small">
                    <mat-label>{{'label.search' |translate}}</mat-label>
                    <input matInput formControlName="search">
                </mat-form-field>
                <span  class="search-icon" (click)="search()"><mat-icon fontIcon="search"></mat-icon></span>
            </div>
        </form>

    </div>
</div>
